import { motion } from "framer-motion";
import { ReplayPlayer } from "./ReplayPlayer";
import { HOST, ASSETS } from "../../content";
import { LuxBg } from "../Reveal";
import { REPLAY_WINDOW } from "../../replayContent";

const line = {
  hidden: { opacity: 0, y: 40, clipPath: "inset(0 0 100% 0)" },
  show: (i) => ({
    opacity: 1,
    y: 0,
    clipPath: "inset(0 0 -10% 0)",
    transition: { delay: 0.25 + i * 0.12, duration: 0.9, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const ReplayHero = ({ onMilestone }) => {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="watch" className="relative min-h-screen grid lg:grid-cols-[45fr_55fr] overflow-hidden" data-testid="replay-hero-section">
      <LuxBg n={3} />
      <div className="relative z-10 flex flex-col justify-center px-6 sm:px-10 lg:pl-16 xl:pl-24 pt-28 pb-8 lg:py-24 order-2 lg:order-1">
        <div className="mono text-[13px] tracking-[0.35em] text-[#FFC631] mb-6" data-testid="replay-eyebrow">
          YOUR REPLAY IS READY — WATCH BEFORE IT EXPIRES
        </div>
        <h1 className="serif font-black uppercase tracking-[-0.03em]" style={{ lineHeight: 0.95 }} data-testid="replay-h1">
          <motion.span custom={0} variants={line} initial="hidden" animate="show" className="block text-[clamp(36px,4.4vw,68px)] text-white">
            HOW VA LOANS WORK DIFFERENTLY
          </motion.span>
          <motion.span custom={1} variants={line} initial="hidden" animate="show" className="block text-[clamp(36px,4.4vw,68px)] text-[#FE0000]">
            AND WHY YOUR BENEFIT MATTERS MORE
          </motion.span>
          <motion.span custom={2} variants={line} initial="hidden" animate="show" className="block text-[clamp(22px,2.7vw,42px)] text-white mt-2">
            — THAN YOUR CREDIT SCORE
          </motion.span>
        </h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.75, duration: 0.8 }}
          className="text-[17px] text-white leading-relaxed mt-8 max-w-xl"
          data-testid="replay-subheadline"
        >
          Watch the full training below, then book your free VA Eligibility &amp; Pre-Approval Review — the same call
          where we map your REG Ascension Path, no hard credit pull required.
        </motion.p>
        <motion.blockquote
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.95, duration: 0.8 }}
          className="border-l-2 border-[#FE0000] pl-5 mt-8 italic text-base text-[#FFC631] max-w-lg"
          data-testid="replay-blockquote"
        >
          The problem was never your credit score. It&apos;s that you were only ever shown one piece of the process.
        </motion.blockquote>
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.1, duration: 0.8 }}>
          <div className="mono text-[13px] tracking-widest text-[#FFC631] mt-8" data-testid="replay-window-line">
            ⏳ This replay is available for {REPLAY_WINDOW} from your registration.
          </div>
          <div className="flex items-center gap-4 mt-10" data-testid="replay-host-module">
            <img src={ASSETS.headshot} alt={HOST.name} className="w-12 h-12 rounded-full border-2 border-[#FE0000] object-cover" data-testid="replay-host-avatar" />
            <div>
              <div className="text-base font-bold text-white">{HOST.name}</div>
              <div className="mono text-[13px] text-white tracking-wider">US Lending Partner PRMG · NMLS# {HOST.nmls}</div>
            </div>
          </div>
        </motion.div>
      </div>

      <div className="relative z-10 flex flex-col justify-center px-6 sm:px-10 lg:pr-16 xl:pr-24 lg:pl-6 pt-24 lg:pt-24 pb-6 lg:pb-12 order-1 lg:order-2">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5, duration: 0.9 }}>
          <ReplayPlayer onMilestone={onMilestone} />
          <button
            data-testid="replay-hero-cta"
            data-cta
            onClick={() => scrollTo("book")}
            className="w-full mt-5 bg-[#FFE100] text-[#12264A] font-bold text-sm uppercase tracking-wide py-4 rounded-md btn-slide hover:-translate-y-0.5 transition-transform duration-200"
          >
            ✓ BOOK MY FREE PRE-APPROVAL REVIEW
          </button>
          <p className="mono text-[13px] text-white text-center mt-3 tracking-wider">
            Free · No hard credit pull · One advocate for financing and representation
          </p>
        </motion.div>
      </div>
    </section>
  );
};
